// extracted by mini-css-extract-plugin
export default {"tooltip":"hq-z","sharingV2":"iq-z","sharingIconsV2":"jq-z","links":"kq-z","link":"lq-z","facebookV2":"mq-z","twitterV2":"nq-z","pinterestV2":"oq-z"};